import {
  createResource,
} from '@resource/resource'

import { prefixAPI } from '@resource/api'

const MODEL_PREFIX = 'map'

const BUILDING_FLOOR_LIST_LINK = prefixAPI('/building/{label}/floor/list/', MODEL_PREFIX)
const PAVILION_RETRIEVE_LINK = prefixAPI('/pavilion/{label}/retrieve/', MODEL_PREFIX)
const SHOP_FLOOR_LIST_LINK = prefixAPI('/shop/{label}/floor/list/', MODEL_PREFIX)

export const buildingFloorList = createResource(BUILDING_FLOOR_LIST_LINK)
export const pavilionRetrieve = createResource(PAVILION_RETRIEVE_LINK)
export const shopFloorList = createResource(SHOP_FLOOR_LIST_LINK)
